"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnfilteredContext = exports.PatientContext = exports.Context = void 0;
var exception_1 = require("../datatypes/exception");
var util_1 = require("../util/util");
var dt = __importStar(require("../datatypes/datatypes"));
var messageListeners_1 = require("./messageListeners");
var Context = /** @class */ (function () {
    function Context(parent, _codeService, _parameters, executionDateTime, messageListener) {
        this.parent = parent;
        this._codeService = _codeService;
        this.context_values = {};
        this.library_context = {};
        this.localId_context = {};
        this.evaluatedRecords = [];
        // TODO: If there is an issue with number of parameters look into cql4browsers fix: 387ea77538182833283af65e6341e7a05192304c
        this.checkParameters(_parameters !== null && _parameters !== void 0 ? _parameters : {}); // not crazy about possibly throwing an error in a constructor, but...
        this._parameters = _parameters || {};
        this.executionDateTime = executionDateTime;
        this.messageListener = messageListener;
    }
    Object.defineProperty(Context.prototype, "parameters", {
        get: function () {
            return this._parameters || (this.parent && this.parent.parameters);
        },
        set: function (params) {
            this.checkParameters(params);
            this._parameters = params;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "codeService", {
        get: function () {
            return this._codeService || (this.parent && this.parent.codeService);
        },
        set: function (cs) {
            this._codeService = cs;
        },
        enumerable: false,
        configurable: true
    });
    Context.prototype.withParameters = function (params) {
        this.parameters = params || {};
        return this;
    };
    Context.prototype.withCodeService = function (cs) {
        this.codeService = cs;
        return this;
    };
    Context.prototype.rootContext = function () {
        if (this.parent) {
            return this.parent.rootContext();
        }
        else {
            return this;
        }
    };
    Context.prototype.findRecords = function (profile, retrieveDetails) {
        return this.parent && this.parent.findRecords(profile, retrieveDetails);
    };
    Context.prototype.childContext = function (context_values) {
        if (context_values === void 0) { context_values = {}; }
        var ctx = new Context(this);
        ctx.context_values = context_values;
        return ctx;
    };
    Context.prototype.getLibraryContext = function (library) {
        return this.parent && this.parent.getLibraryContext(library);
    };
    Context.prototype.getLocalIdContext = function (localId) {
        return this.parent && this.parent.getLocalIdContext(localId);
    };
    Context.prototype.getParameter = function (name) {
        return this.parent && this.parent.getParameter(name);
    };
    Context.prototype.getParentParameter = function (name) {
        if (this.parent) {
            if (this.parent.parameters[name] != null) {
                return this.parent.parameters[name];
            }
            else {
                return this.parent.getParentParameter(name);
            }
        }
    };
    Context.prototype.getTimezoneOffset = function () {
        if (this.executionDateTime != null) {
            return this.executionDateTime.timezoneOffset;
        }
        else if (this.parent && this.parent.getTimezoneOffset != null) {
            return this.parent.getTimezoneOffset();
        }
        else {
            throw new exception_1.Exception('No Timezone Offset has been set');
        }
    };
    Context.prototype.getExecutionDateTime = function () {
        if (this.executionDateTime != null) {
            return this.executionDateTime;
        }
        else if (this.parent && this.parent.getExecutionDateTime != null) {
            return this.parent.getExecutionDateTime();
        }
        else {
            throw new exception_1.Exception('No Execution DateTime has been set');
        }
    };
    Context.prototype.getMessageListener = function () {
        if (this.messageListener != null) {
            return this.messageListener;
        }
        else if (this.parent && this.parent.getMessageListener != null) {
            return this.parent.getMessageListener();
        }
        else {
            return new messageListeners_1.NullMessageListener();
        }
    };
    Context.prototype.getValueSet = function (name, library) {
        return this.parent && this.parent.getValueSet(name, library);
    };
    Context.prototype.getCodeSystem = function (name) {
        return this.parent && this.parent.getCodeSystem(name);
    };
    Context.prototype.getCode = function (name) {
        return this.parent && this.parent.getCode(name);
    };
    Context.prototype.getConcept = function (name) {
        return this.parent && this.parent.getConcept(name);
    };
    Context.prototype.get = function (identifier) {
        // Check for undefined because if its null, we actually *do* want to return null (rather than
        // looking at parent), but if it's really undefined, *then* look at the parent
        if (typeof this.context_values[identifier] !== 'undefined') {
            return this.context_values[identifier];
        }
        else if (identifier === '$this') {
            return this.context_values;
        }
        else {
            return this.parent != null && this.parent.get(identifier);
        }
    };
    Context.prototype.set = function (identifier, value) {
        this.context_values[identifier] = value;
    };
    Context.prototype.setLocalIdWithResult = function (localId, value) {
        // Temporary fix. Real fix will be to return a list of all result values for a given localId.
        var ctx = this.localId_context[localId];
        if (ctx === false || ctx === null || ctx === undefined || ctx.length === 0) {
            this.localId_context[localId] = value;
        }
    };
    Context.prototype.getLocalIdResult = function (localId) {
        return this.localId_context[localId];
    };
    // Returns an object of objects containing each library name
    // with the localIds and result values
    Context.prototype.getAllLocalIds = function () {
        var localIdResults = {};
        // Add the localIds and result values from the main library
        localIdResults[this.parent.source.library.identifier.id] = {};
        localIdResults[this.parent.source.library.identifier.id] = this.localId_context;
        // Iterate over support libraries and store localIds
        for (var libName in this.library_context) {
            var lib = this.library_context[libName];
            this.supportLibraryLocalIds(lib, localIdResults);
        }
        return localIdResults;
    };
    // Recursive function that will grab nested support library localId results
    Context.prototype.supportLibraryLocalIds = function (lib, localIdResults) {
        var _this = this;
        // Set library identifier name as the key and the object of localIds with their results as the value
        // if it already exists then we need to merge the results instead of overwriting
        if (localIdResults[lib.library.source.library.identifier.id] != null) {
            this.mergeLibraryLocalIdResults(localIdResults, lib.library.source.library.identifier.id, lib.localId_context);
        }
        else {
            localIdResults[lib.library.source.library.identifier.id] = lib.localId_context;
        }
        // Iterate over any support libraries in the current support library
        Object.values(lib.library_context).forEach(function (supportLib) {
            _this.supportLibraryLocalIds(supportLib, localIdResults);
        });
    };
    // Merges the localId results for a library into the already collected results. The logic used for which result
    // to keep is the same as the logic used above in setLocalIdWithResult, "falsey" results are always replaced.
    Context.prototype.mergeLibraryLocalIdResults = function (localIdResults, libraryId, libraryResults) {
        for (var localId in libraryResults) {
            var localIdResult = libraryResults[localId];
            var existingResult = localIdResults[libraryId][localId];
            // overwite this localid result if the existing result is "falsey". future work could track all results for each localid
            if (existingResult === false ||
                existingResult === null ||
                existingResult === undefined ||
                existingResult.length === 0) {
                localIdResults[libraryId][localId] = localIdResult;
            }
        }
    };
    Context.prototype.checkParameters = function (params) {
        for (var pName in params) {
            var pVal = params[pName];
            var pDef = this.getParameter(pName);
            if (pVal == null) {
                return; // Null can theoretically be any type
            }
            if (typeof pDef === 'undefined') {
                return; // This will happen if the parameter is declared in a different (included) library
            }
            else if (pDef.parameterTypeSpecifier != null &&
                !this.matchesTypeSpecifier(pVal, pDef.parameterTypeSpecifier)) {
                throw new Error("Passed in parameter '".concat(pName, "' is wrong type"));
            }
            else if (pDef['default'] != null && !this.matchesInstanceType(pVal, pDef['default'])) {
                throw new Error("Passed in parameter '".concat(pName, "' is wrong type"));
            }
        }
        return true;
    };
    Context.prototype.matchesTypeSpecifier = function (val, spec) {
        switch (spec.type) {
            case 'NamedTypeSpecifier':
                return this.matchesNamedTypeSpecifier(val, spec);
            case 'ListTypeSpecifier':
                return this.matchesListTypeSpecifier(val, spec);
            case 'TupleTypeSpecifier':
                return this.matchesTupleTypeSpecifier(val, spec);
            case 'IntervalTypeSpecifier':
                return this.matchesIntervalTypeSpecifier(val, spec);
            case 'ChoiceTypeSpecifier':
                return this.matchesChoiceTypeSpecifier(val, spec);
            default:
                return true; // default to true when we don't know
        }
    };
    Context.prototype.matchesListTypeSpecifier = function (val, spec) {
        var _this = this;
        return ((0, util_1.typeIsArray)(val) && val.every(function (x) { return _this.matchesTypeSpecifier(x, spec.elementType); }));
    };
    Context.prototype.matchesTupleTypeSpecifier = function (val, spec) {
        var _this = this;
        // TODO: Spec is not clear about exactly how tuples should be matched
        return (val != null &&
            typeof val === 'object' &&
            !(0, util_1.typeIsArray)(val) &&
            !val.isInterval &&
            !val.isConcept &&
            !val.isCode &&
            !val.isDateTime &&
            !val.isDate &&
            !val.isQuantity &&
            spec.element.every(function (x) {
                return typeof val[x.name] === 'undefined' ||
                    _this.matchesTypeSpecifier(val[x.name], x.elementType);
            }));
    };
    Context.prototype.matchesIntervalTypeSpecifier = function (val, spec) {
        return (val.isInterval &&
            (val.low == null || this.matchesTypeSpecifier(val.low, spec.pointType)) &&
            (val.high == null || this.matchesTypeSpecifier(val.high, spec.pointType)));
    };
    Context.prototype.matchesChoiceTypeSpecifier = function (val, spec) {
        var _this = this;
        return spec.choice.some(function (c) { return _this.matchesTypeSpecifier(val, c); });
    };
    Context.prototype.matchesNamedTypeSpecifier = function (val, spec) {
        if (val == null) {
            return true;
        }
        switch (spec.name) {
            case '{urn:hl7-org:elm-types:r1}Boolean':
                return typeof val === 'boolean';
            case '{urn:hl7-org:elm-types:r1}Decimal':
                return typeof val === 'number';
            case '{urn:hl7-org:elm-types:r1}Integer':
                return typeof val === 'number' && Math.floor(val) === val;
            case '{urn:hl7-org:elm-types:r1}String':
                return typeof val === 'string';
            case '{urn:hl7-org:elm-types:r1}Concept':
                return val && val.isConcept;
            case '{urn:hl7-org:elm-types:r1}Code':
                return val && val.isCode;
            case '{urn:hl7-org:elm-types:r1}DateTime':
                return val && val.isDateTime;
            case '{urn:hl7-org:elm-types:r1}Date':
                return val && val.isDate;
            case '{urn:hl7-org:elm-types:r1}Quantity':
                return val && val.isQuantity;
            case '{urn:hl7-org:elm-types:r1}Time':
                return val && val.isTime && val.isTime();
            default:
                // Use the data model's implementation of _is, if it is available
                if (typeof val._is === 'function') {
                    return val._is(spec);
                }
                // If the value is an array or interval, then we assume it cannot be cast to a
                // named type. Technically, this is not 100% true because a modelinfo can define
                // a named type whose base type is a list or interval.  But none of our models
                // (FHIR, QDM, QICore) do that, so for those models, this approach will always be
                // correct.
                if (Array.isArray(val) || val.isInterval) {
                    return false;
                }
                // Otherwise just default to true to match legacy behavior.
                //
                // NOTE: This is also where arbitrary tuples land because they will not have
                // an "is" function and we don't encode the type information into the runtime
                // objects so we can't easily determine their type. We can't reject them,
                // else things like `Encounter{ id: "1" } is Encounter` would return false.
                // So for now we allow false positives in order to avoid false negatives.
                return true;
        }
    };
    Context.prototype.matchesInstanceType = function (val, inst) {
        if (inst.isBooleanLiteral) {
            return typeof val === 'boolean';
        }
        else if (inst.isDecimalLiteral) {
            return typeof val === 'number';
        }
        else if (inst.isIntegerLiteral) {
            return typeof val === 'number' && Math.floor(val) === val;
        }
        else if (inst.isStringLiteral) {
            return typeof val === 'string';
        }
        else if (inst.isCode) {
            return val && val.isCode;
        }
        else if (inst.isConcept) {
            return val && val.isConcept;
        }
        else if (inst.isTime && inst.isTime()) {
            return val && val.isTime && val.isTime();
        }
        else if (inst.isDate) {
            return val && val.isDate;
        }
        else if (inst.isDateTime) {
            return val && val.isDateTime;
        }
        else if (inst.isQuantity) {
            return val && val.isQuantity;
        }
        else if (inst.isList) {
            return this.matchesListInstanceType(val, inst);
        }
        else if (inst.isTuple) {
            return this.matchesTupleInstanceType(val, inst);
        }
        else if (inst.isInterval) {
            return this.matchesIntervalInstanceType(val, inst);
        }
        return true; // default to true when we don't know for sure
    };
    Context.prototype.matchesListInstanceType = function (val, list) {
        var _this = this;
        return ((0, util_1.typeIsArray)(val) && val.every(function (x) { return _this.matchesInstanceType(x, list.elements[0]); }));
    };
    Context.prototype.matchesTupleInstanceType = function (val, tpl) {
        var _this = this;
        return (typeof val === 'object' &&
            !(0, util_1.typeIsArray)(val) &&
            tpl.elements.every(function (x) {
                return typeof val[x.name] === 'undefined' || _this.matchesInstanceType(val[x.name], x.value);
            }));
    };
    Context.prototype.matchesIntervalInstanceType = function (val, ivl) {
        var pointType = ivl.low != null ? ivl.low : ivl.high;
        return (val.isInterval &&
            (val.low == null || this.matchesInstanceType(val.low, pointType)) &&
            (val.high == null || this.matchesInstanceType(val.high, pointType)));
    };
    return Context;
}());
exports.Context = Context;
var PatientContext = /** @class */ (function (_super) {
    __extends(PatientContext, _super);
    function PatientContext(library, patient, codeService, parameters, executionDateTime, messageListener) {
        if (executionDateTime === void 0) { executionDateTime = dt.DateTime.fromJSDate(new Date()); }
        if (messageListener === void 0) { messageListener = new messageListeners_1.NullMessageListener(); }
        var _this = _super.call(this, library, codeService, parameters, executionDateTime, messageListener) || this;
        _this.library = library;
        _this.patient = patient;
        return _this;
    }
    PatientContext.prototype.rootContext = function () {
        return this;
    };
    PatientContext.prototype.getLibraryContext = function (library) {
        if (this.library_context[library] == null) {
            this.library_context[library] = new PatientContext(this.get(library), this.patient, this.codeService, this.parameters, this.executionDateTime);
        }
        return this.library_context[library];
    };
    PatientContext.prototype.getLocalIdContext = function (localId) {
        if (this.localId_context[localId] == null) {
            this.localId_context[localId] = new PatientContext(this.get(localId), this.patient, this.codeService, this.parameters, this.executionDateTime);
        }
        return this.localId_context[localId];
    };
    PatientContext.prototype.findRecords = function (profile, retrieveDetails) {
        return this.patient && this.patient.findRecords(profile, retrieveDetails);
    };
    return PatientContext;
}(Context));
exports.PatientContext = PatientContext;
var UnfilteredContext = /** @class */ (function (_super) {
    __extends(UnfilteredContext, _super);
    function UnfilteredContext(library, results, codeService, parameters, executionDateTime, messageListener) {
        if (executionDateTime === void 0) { executionDateTime = dt.DateTime.fromJSDate(new Date()); }
        if (messageListener === void 0) { messageListener = new messageListeners_1.NullMessageListener(); }
        var _this = _super.call(this, library, codeService, parameters, executionDateTime, messageListener) || this;
        _this.library = library;
        _this.results = results;
        return _this;
    }
    UnfilteredContext.prototype.rootContext = function () {
        return this;
    };
    UnfilteredContext.prototype.findRecords = function (_template) {
        throw new exception_1.Exception('Retreives are not currently supported in Unfiltered Context');
    };
    UnfilteredContext.prototype.getLibraryContext = function (_library) {
        throw new exception_1.Exception('Library expressions are not currently supported in Unfiltered Context');
    };
    UnfilteredContext.prototype.get = function (identifier) {
        //First check to see if the identifier is a unfiltered context expression that has already been cached
        if (this.context_values[identifier]) {
            return this.context_values[identifier];
        }
        //if not look to see if the library has a unfiltered expression of that identifier
        if (this.library[identifier] && this.library[identifier].context === 'Unfiltered') {
            return this.library.expressions[identifier];
        }
        //lastley attempt to gather all patient level results that have that identifier
        // should this compact null values before return ?
        return Object.values(this.results.patientResults).map(function (pr) { return pr[identifier]; });
    };
    return UnfilteredContext;
}(Context));
exports.UnfilteredContext = UnfilteredContext;
//# sourceMappingURL=context.js.map